import React, { useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import {
    APIProvider,
    Map as GoogleMap,
    Marker,
    InfoWindow,
} from "@vis.gl/react-google-maps";
import nosotros from "../../assets/nosotros.png";

const Map2 = ({ listings = [], checkIn, checkOut, guests }) => {
    const [selectedPosition, setSelectedPosition] = useState(null);
    const mapRef = useRef(null);
    const navigate = useNavigate();
    const defaultLat = listings[0]?.lat || 4.65;
    const defaultLng = listings[0]?.lng || -74.05;
    const defaultCenter = { lat: defaultLat, lng: defaultLng };

    const handleRedirect = (listingId, city) => {
        // navigate(`/listings/${listingId}?`);
        navigate(`/listings/${listingId}?city=${encodeURIComponent(city)}&checkIn=${encodeURIComponent(checkIn)}&checkOut=${encodeURIComponent(checkOut)}&guests=${encodeURIComponent(guests)}`);
    };

    const handleMapLoad = (mapInstance) => {
        mapRef.current = mapInstance;
        if (listings.length > 0) {
            const bounds = new window.google.maps.LatLngBounds();

            listings.forEach((item) => {
                bounds.extend({ lat: item.lat, lng: item.lng });
            });
            mapInstance.fitBounds(bounds);
        }
    };

    // 🔁 Agrupar por coordenadas exactas
    const groupByCoordinates = () => {
        const coordMap = new Map();
        listings.forEach((item) => {
            const key = `${item.lat.toFixed(6)}-${item.lng.toFixed(6)}`;
            if (!coordMap.has(key)) {
                coordMap.set(key, []);
            }
            coordMap.get(key).push(item);
        });
        return coordMap;
    };

    // 🔄 Aplicar offset si hay múltiples ubicaciones en la misma coordenada
    const applyOffsetToGroupedListings = () => {
        const grouped = groupByCoordinates();
        const adjusted = [];

        grouped.forEach((group) => {
            if (group.length === 1) {
                const item = group[0];
                adjusted.push({ ...item, adjustedLat: item.lat, adjustedLng: item.lng });
            } else {
                const offset = 0.00005;
                group.forEach((item, index) => {
                    const angle = (index * 360) / group.length;
                    const radians = angle * (Math.PI / 180);
                    const adjustedLat = item.lat + offset * Math.cos(radians);
                    const adjustedLng = item.lng + offset * Math.sin(radians);
                    adjusted.push({ ...item, adjustedLat, adjustedLng });
                });
            }
        });

        return adjusted;
    };

    const adjustedListings = applyOffsetToGroupedListings();

    return (
        <APIProvider apiKey={"AIzaSyAiaT-WEhevWJziUSsuNH-SgM00Y3cXp-M"}>
            <div
                style={{
                    marginTop: "15px",
                    height: "80vh",
                    width: "90%",
                    marginLeft: "auto",
                    marginRight: "auto",
                }}
            >
                <GoogleMap
                    style={{ width: "100%", height: "100%" }}
                    defaultCenter={defaultCenter}
                    defaultZoom={14}
                    gestureHandling="greedy"
                    disableDefaultUI={false}
                    onLoad={handleMapLoad}
                >
                    {adjustedListings.map((loc, index) => (
                        <Marker
                            key={index}
                            position={{ lat: loc.adjustedLat, lng: loc.adjustedLng }}
                            icon={{
                                url: nosotros,
                                scaledSize: { width: 30, height: 30 },
                            }}
                            onClick={() => setSelectedPosition(loc)}
                        />
                    ))}

                    {selectedPosition && (
                        <InfoWindow
                            position={{
                                lat: selectedPosition.adjustedLat,
                                lng: selectedPosition.adjustedLng,
                            }}
                            onCloseClick={() => setSelectedPosition(null)}
                        >
                            <div
                                style={{
                                    maxWidth: "220px",
                                    display: "flex",
                                    flexDirection: "column",
                                    fontFamily: "Arial, sans-serif",
                                    paddingTop: "2px"
                                }}
                            >
                                {selectedPosition?.image && (
                                    <img
                                        src={selectedPosition.image}
                                        alt={selectedPosition.name}
                                        style={{
                                            width: "100%",
                                            height: "120px",
                                            objectFit: "cover",
                                            borderRadius: "6px",
                                            marginBottom: "20px",
                                        }}
                                    />
                                )}
                                <p
                                    onClick={() => handleRedirect(selectedPosition.listingId, selectedPosition.city)}
                                    style={{
                                        fontSize: "14px",
                                        fontWeight: "bold",
                                        margin: "0 0 2px 0",
                                        lineHeight: "1.2",
                                        cursor: "pointer",
                                        color: "#007bff"
                                    }}
                                >
                                    {selectedPosition.name}
                                </p>
                                <p
                                    style={{
                                        fontSize: "13px",
                                        color: "#333",
                                        margin: 0
                                    }}
                                >
                                    {selectedPosition.label}
                                </p>
                            </div>
                        </InfoWindow>
                    )}
                </GoogleMap>
            </div>
        </APIProvider>
    );
};

export default Map2;
